import Vue from 'vue'

// 第一步 引用路由
import Router from 'vue-router'

// 第二步 使用路由
Vue.use(Router)

const routes = [
  {
    path: '/',
    component: (resolve) => require(['@/views/home'], resolve)
  },
  {
    path: '/about',
    component: (resolve) => require(['@/views/about'], resolve)
  },
  {
    path: '/product',
    component: (resolve) => require(['@/views/product'], resolve)
  },
  {
    path: '/solve',
    component: (resolve) => require(['@/views/solve'], resolve)
  },
  {
    path: '/contact',
    component: (resolve) => require(['@/views/contact'], resolve)
  },
  {
    path: '/job',
    component: (resolve) => require(['@/views/job'], resolve)
  },
]
  
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({y: 0}),
  routes
});

router.beforeEach((to, from, next) => {
  next();
});
router.afterEach((to, from, next) => {

});

export default router;